import { makeRequest } from 'utils/REST';
import { OUR_BE_REST_CONTENT_VAIX_PATH } from 'constants/appConfig';

class ComboService {
    request(requestType, url, data) {
        return makeRequest(requestType, url, data)
            .then((response) => {
                return response.json();
            })
            .then((data) => {
                return data;
            });
    }

    post(method, data) {
        return this.request(
            'post',
            OUR_BE_REST_CONTENT_VAIX_PATH + method,
            data
        );
    }

    get(method, data) {
        return this.request(
            'get',
            OUR_BE_REST_CONTENT_VAIX_PATH + method,
            data
        );
    }

    getCombo(count = 3) {
        return this.get(
            `popularSlips?count=${count}&location=web%3Arecommended`
        );
    }
}

export default new ComboService();
